<script setup>
import { nextTick, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  server: {
    type: Object,
    required: true,
  },
  tool: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['close']);
const { t } = useI18n();
const store = useStore();

const dialogRef = ref(null);

const uiFlags = useMapGetter('wgptMcpServers/getUIFlags');

const handleSubmit = async () => {
  try {
    await store.dispatch('wgptMcpServers/deleteTool', {
      serverId: props.server.id,
      id: props.tool.id,
    });
    useAlert(t('WGPT_MCP_SERVERS.EDIT.TOOLS.DELETE_TOOL.API.SUCCESS_MESSAGE'));
    dialogRef.value.close();
    emit('close');
  } catch (error) {
    useAlert(
      error?.message ||
        t('WGPT_MCP_SERVERS.EDIT.TOOLS.DELETE_TOOL.API.ERROR_MESSAGE')
    );
  }
};

const open = () => {
  nextTick(() => {
    dialogRef.value?.open();
  });
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('WGPT_MCP_SERVERS.EDIT.TOOLS.DELETE_TOOL.CONFIRM.TITLE')"
    :description="
      t('WGPT_MCP_SERVERS.EDIT.TOOLS.DELETE_TOOL.CONFIRM.MESSAGE', {
        name: tool.name,
      })
    "
    :is-loading="uiFlags.isUpdating"
    :disable-confirm-button="uiFlags.isUpdating"
    :confirm-button-label="
      t('WGPT_MCP_SERVERS.EDIT.TOOLS.DELETE_TOOL.CONFIRM.YES')
    "
    :cancel-button-label="
      t('WGPT_MCP_SERVERS.EDIT.TOOLS.DELETE_TOOL.CONFIRM.NO')
    "
    @confirm="handleSubmit"
    @close="emit('close')"
  />
</template>
